import {
    MDBContainer,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane,
} from "mdb-react-ui-kit";
import { useState, useMemo } from "react";
import SignalsTab from "./tabs/SignalsTab";
import RoutingToolsTab from "./tabs/RoutingToolsTab";
import NotificationRulesTab from "./tabs/NotificationRulesTab";
import { checkIsAdmin } from "../../helpers";

const BASE_TAB_CONFIG = [
    {
        key: "signals",
        label: "Signals",
        component: SignalsTab,
    },
    {
        key: "routing-tools",
        label: "Routing tools",
        component: RoutingToolsTab,
        adminOnly: true,
    },
    {
        key: "notification-rules",
        label: "Notification rules",
        component: NotificationRulesTab,
        adminOnly: true,
    },
];

const Settings = () => {
    const isAdmin = checkIsAdmin();

    const visibleTabs = useMemo(
        () => BASE_TAB_CONFIG.filter(tab => !tab.adminOnly || isAdmin),
        [isAdmin]
    );

    const [currentTab, setCurrentTab] = useState(visibleTabs[0].key);

    const ActiveTabComponent = visibleTabs.find(tab => tab.key === currentTab)?.component;

    return (
        <MDBContainer className="my-5">
            <MDBTabs className="mb-3">
                {visibleTabs.map(({ key, label }) => (
                    <MDBTabsItem key={key} onClick={() => setCurrentTab(key)}>
                        <MDBTabsLink active={currentTab === key}>{label}</MDBTabsLink>
                    </MDBTabsItem>
                ))}
            </MDBTabs>
            <MDBTabsContent>
                <MDBTabsPane show>
                    <ActiveTabComponent isActiveTab />
                </MDBTabsPane>
            </MDBTabsContent>
        </MDBContainer>
    );
};

export default Settings;
